// extracted by mini-css-extract-plugin
export default {"manualMigrationContainer":"ManualMigration_manualMigrationContainer__KUP8B"};